import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useMemo } from 'react';
import { SuspenseBoundary } from '../../../shared/SuspenseBoundary';
import { useAppPermissionTranslationsPublic } from '../translation';
import ScopesAuthorization from './ScopesAuthorization';
import { jsx as _jsx } from "react/jsx-runtime";
const Loading = () => /*#__PURE__*/_jsx(LoadingSpinner, {
  grow: true,
  minHeight: 200
});
const useTranslateScopeGroupsPublic = scopeGroups => {
  // since scopeGroups are synced with app permissions, we can converge on the app permission names
  const appPermissionNames = useMemo(() => {
    return new Set(scopeGroups.map(scopeGroup => scopeGroup.name));
  }, [scopeGroups]);
  const translations = useAppPermissionTranslationsPublic(appPermissionNames);
  return useMemo(() => {
    return scopeGroups.map(scopeGroup => {
      var _translations$get;
      return Object.assign({}, scopeGroup, {
        translations: (_translations$get = translations.get(scopeGroup.name)) !== null && _translations$get !== void 0 ? _translations$get : {
          name: scopeGroup.name,
          ungatedForBETranslation: true,
          shortDescription: undefined,
          longDescription: undefined
        }
      });
    });
  }, [scopeGroups, translations]);
};
const ScopesAuthorizationContentPublic = ({
  scopes
}) => {
  const translatedScopes = useTranslateScopeGroupsPublic(scopes);
  return /*#__PURE__*/_jsx(ScopesAuthorization, {
    scopes: translatedScopes
  });
};
const ScopesAuthorizationContainerPublic = props => {
  return /*#__PURE__*/_jsx(SuspenseBoundary, {
    fallback: /*#__PURE__*/_jsx(Loading, {}),
    children: /*#__PURE__*/_jsx(ScopesAuthorizationContentPublic, {
      scopes: props.scopes
    })
  });
};
export default ScopesAuthorizationContainerPublic;